<template>
  <div class="Others6Charts" :style="Style">
    <!-- :style="{
            fontSize: `${$w_Ratio(20 + getShowfontSizeBase(), $store)}px`,
          }" -->
    <!-- 出入车辆 -->
    <div class="cars-in-out">
      <!-- 数据 -->
      <div
        class="data"
        :class="getStyle('Style')"
        v-for="(item, index) in carData"
        :key="index"
        :style="{
          padding: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px 
          ${$w_Ratio(8 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <div
          class="d-left"
          :style="{
            fontSize: `${titleFontSize}px`,
          }"
        >
          <span>{{ item.parkingName }}</span>
        </div>
        <div class="d-right">
          <div
            :style="{
              marginBottom: `${$w_Ratio(-1 + getShowfontSizeBase(), $store)}px`,
            }"
            class="d-item"
            v-for="(itemc, indexc) in item.data"
            :key="indexc"
          >
            <!-- 标题 -->
            <div
              class="title"
              :style="{
                fontSize: `${xFontSize}px`,
              }"
            >
              <!-- 点 -->
              <div
                class="dot"
                :style="{
                  width: `${$w_Ratio(-5 + getShowfontSizeBase(), $store)}px`,
                  minWidth: '5px',
                  minHeight: '5px',
                  height: `${$h_Ratio(-5 + getShowfontSizeBase(), $store)}px`,
                  marginRight: '10px',
                }"
              ></div>
              <span>{{ itemc.name }}</span>
            </div>
            <!-- 值 -->
            <div
              class="value"
              :style="{
                marginLeft: `${$w_Ratio(0 + getShowfontSizeBase(), $store)}px`,
                fontSize: `${yFontSize}px`,
              }"
            >
              <vue-animate-number :value="itemc.value" :duration="duration" :formatValue="formatToPrice" />
              <!-- Unit 单位 -->
              <span>{{ Unit }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div>
  </div>
</template>

<script>
import VueAnimateNumber from '../../../count-animate-number/AnimatedNumber';
import { getFilterValue } from '../../../utils/tool';
import { request } from '../../../common/request';
export default {
  name: 'Others6Charts',
  components: {
    VueAnimateNumber,
    // NumberScroll,
  },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
    ComboBoxCharts: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      car: ['总停车位', '剩余车位'],
      carData: [
        {
          parkingName: '数据加载中',
          data: [
            {
              name: '数据项',
              value: 0,
              // dotColor: 'red',
            },
            {
              name: '数据项',
              value: 0,
              // dotColor: '#aec',
            },
          ],
        },
      ],
      params: {}, // 请求参数
      paramsCopy: {},
      Unit: '',
      noData: false, // 无数据
      duration: 2000,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    // this.getApiDataResByFilterAndResponseQuery();

    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    console.log(this.params, 'aaaaaaaaa');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
    titleFontSize() {
      return this.Configuration.propertyData.fontStyle.value.titleSize;
    },
    xFontSize() {
      return this.Configuration.propertyData.fontStyle.value.xAxisSize;
    },
    yFontSize() {
      return this.Configuration.propertyData.fontStyle.value.yAxisSize;
    },
  },
  methods: {
    getStyle(e = '') {
      let style = {};
      switch (this.style) {
        case 'V1Style':
          style['V1' + e] = true;
          break;
        case 'V2Style':
          style['V2' + e] = true;
          break;
        case 'V3Style':
          style['V3' + e] = true;
          break;
        case 'V4Style':
          style['V4' + e] = true;
          break;
        case 'V5Style':
          style['V5' + e] = true;
          break;
        case 'V6Style':
          style['V6' + e] = true;
          break;
        case 'V7Style':
          style['V7' + e] = true;
          break;
        case 'V8Style':
          style['V8' + e] = true;
          break;
        case 'V9Style':
          style['V9' + e] = true;
          break;
        case 'V10Style':
          style['V10' + e] = true;
          break;
        case 'V11Style':
          style['V11' + e] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    formatToPrice(value) {
      //使用tofixed（0）限制跳动的小数位数
      return `<span>${Number(value).toFixed(0)}</span>`;
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      if (Object.keys(ParamData).length == 0 || ParamData.source.length == 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let units = '';
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (this.Configuration.propertyData?.textComponentUnits?.value) {
        units = this.Configuration.propertyData.textComponentUnits.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      this.Unit = units;
      console.log(source);
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      let parking = [];
      let carData = [];

      function DealData() {
        source.forEach(item => {
          parking.push(item.x);
        });
        parking = [...new Set(parking)];
        seriesList.forEach(item => {
          carData.push({
            parkingName: item,
            data: [],
          });
        });
        carData.forEach(s => {
          source.forEach((item, index) => {
            let total = 0;
            let surplus = 0;
            if (item.s === s.parkingName) {
              s['data'].push({
                name: item.x,
                value: item.y,
              });
            }
          });
        });
      }

      DealData();
      console.log(parking, carData, '5745646843468');
      this.car = parking;
      this.carData = carData;

      // console.log('------------------------------------aaaa');
      // console.log(xyData);
      // this.data1.unit = unit;
      // this.data2.unit = unit;
      // this.data3.unit = unit;

      // if (xyData[0]) {
      //   this.data1.name = xyData[0].name;
      //   this.data1.value = xyData[0].value;
      // }
      // if (xyData[1]) {
      //   this.data2.name = xyData[1].name;
      //   this.data2.value = xyData[1].value;
      // }
      // if (xyData[2]) {
      //   this.data3.name = xyData[2].name;
      //   this.data3.value = xyData[2].value;
      // }

      // console.log(unit);
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);
          data.source.forEach(item => {
            item.y = 0;
          });

          this.setEchartsOptions(data);
          setTimeout(() => {
            this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData));
          }, 0);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setTimeout(() => {
          console.log('任务执行staticData');
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setTimeout(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除之前的 interval 任务（如果有的话）
      if (this.apiIntervalTaskID) {
        clearInterval(this.apiIntervalTaskID);
      }

      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      console.log(ChartsData?.apiData?.isUseInterval, '5454544548545454');

      // 判断是否使用 apiData，使用动态 interval 请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 定义一个异步函数来处理数据请求和更新
        const fetchAndUpdateData = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        // 首次调用
        fetchAndUpdateData();

        // 设置 interval 定时任务
        this.apiIntervalTaskID = setInterval(fetchAndUpdateData, ChartsData?.apiData?.apiInterval * 1000);
        console.log('开启 interval 任务，间隔请求');
      } else if (ChartsData?.currenEntry === 'apiData') {
        // 只处理一次请求
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // async startApiIntervalTask() {
    //   clearInterval(this.apiIntervalTaskID);
    //   let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    //   console.log(ChartsData?.apiData?.isUseInterval, '5454544548545454');
    //   // 判断是否使用apiData，使用动态interval请求
    //   if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
    //     // 开启interval任务 间隔请求
    //     let func = async () => {
    //       let res = await this.getApiDataResByFilterAndResponseQuery();
    //       this.setEchartsOptions(res);
    //     };
    //     func();
    //     this.apiIntervalTaskID = setTimeout(async () => {
    //       console.log('开启interval任务 间隔请求');
    //       func();
    //     }, ChartsData?.apiData?.apiInterval * 1000);
    //     // console.log(ChartsData?.apiData?.apiInterval);
    //   } else if (ChartsData?.currenEntry === 'apiData') {
    //     // console.log('不开启interval任务 只处理一次请求');
    //     let res = await this.getApiDataResByFilterAndResponseQuery();
    //     this.setEchartsOptions(res);
    //   }
    // },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');
          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // let params = ChartsData.apiData.apiPostParams || {};
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function(data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              console.log(arryQuery, 'arryQuery arryQuery');
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            // console.log(ChartsData.apiData, 'ChartsData.apiData');
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '多行分组文字',
    componentName: 'Others6Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others6Charts.png',
    id: '',
    style: {
      width: 462,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['停车场1', '停车场2'],
            source: [
              {
                s: '停车场1',
                x: '总车位数',
                y: 100,
              },
              {
                s: '停车场1',
                x: '剩余车位数',
                y: 10,
              },
              {
                s: '停车场2',
                x: '总车位数',
                y: 200,
              },
              {
                s: '停车场2',
                x: '剩余车位数',
                y: 22,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 14,
          xAxisColor: '#fff',
          yAxisSize: 14,
          yAxisColor: '#fff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },

      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      textComponentUnits: {
        propertyComponentName: 'MapTextConfiger',
        value: '元',
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others6Charts {
  color: white;
  background-color: transparent !important;
  width: 100%;
  height: 100%;
  border-radius: 2px;

  .no-data {
    width: 100%;
    height: 100%;
    // background: #000;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ccc;
  }

  .example1 {
    transition: all 3s;
  }

  .cars-in-out {
    width: 100%;
    /* display: flex; */
    flex-direction: column;
    height: 100%;

    /* overflow-y: scroll; */
    .data {
      min-height: 55px;
      height: auto;
      margin-top: 10px !important;
      margin-right: 4px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background: rgba(1, 68, 32, 0.397);
      border-radius: 6px;

      &:nth-child(1) {
        margin-top: 0;
      }

      .d-left {
        width: 40%;
        font-weight: bold;
      }

      .d-right {
        width: 56%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        /* width: 36%;
         height: 100%;
         display: flex;
         align-items: center;
         flex-direction: column;
         justify-content: center; */

        .d-item {
          display: flex;
          justify-content: space-between;

          &:nth-child(2) .title .dot {
            background: #ff7d4f;
          }
          &:nth-child(2) .value {
            color: #ff7d4f;
          }

          .title {
            display: flex;
            align-items: center;
            &::after {
              display: none;
            }
            .dot {
              border-radius: 50%;
              background: #8eff8d;
            }
          }

          .value {
            // background: linear-gradient(to bottom, #fff, #8eff8d);
            background: #8eff8d;
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-weight: bold;
          }
        }
      }
    }
  }

  .V1Style {
    background: rgba(3, 67, 123, 0.39) !important;
  }

  .V3Style {
    /* background: rgba(3, 67, 123, 0.39) !important; */
    background: linear-gradient(
      to bottom,
      rgba(5, 44, 87, 0.7),
      transparent 20%,
      transparent,
      transparent 80%,
      rgba(5, 44, 87, 0.7) 100%
    ) !important;

    .d-left {
      span {
        color: #b1d3fd !important;
      }
    }

    .d-right {
      .title {
        color: #b1d3fd !important;
      }
    }
  }

  .V4Style {
    background: rgba(119, 49, 190, 0.377) !important;
  }

  .V5Style {
    background: rgba(1, 68, 32, 0.397) !important;
  }

  .V6Style {
    background: #001a45 !important;
  }

  .V7Style {
    background: #001a45 !important;
  }

  .V8Style {
    color: #000;
    background: #fff !important;

    .value {
      background-image: -webkit-linear-gradient(bottom, #7a630dbf, #641414d9) !important;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .V9Style {
    background: rgba(8, 39, 55) !important;
  }
  .V11Style {
    &:nth-child(odd) {
      background: #4c2d08bf !important;
      /* // 单数行背景色 */
    }
    &:nth-child(even) {
      background: #36200885 !important;
      /* // 双数行背景色 */
    }
    /* background: #4c2d08bf !important; */

    .d-item:nth-child(2) .title .dot {
      background: #0398c9 !important;
    }
    .d-item .title .dot {
      background: #fd9500 !important;
    }
    .d-left {
      width: 26% !important;
    }
    .cars-in-out .data .d-right .d-item:nth-child(2) .value {
      color: #0397c900 !important;
    }

    .data .d-right .d-item .value {
      background: #8eff8d;
    }
    .d-item .value {
      background-image: -webkit-linear-gradient(top, #ffffff, #fffb4c) !important;
      color: #00000000 !important;
      position: relative !important;
      right: 12% !important;
    }
  }
}

/**滚动条的宽度*/
::-webkit-scrollbar {
  width: 2px;
  //padding-left: 10px;
}

//滚动条的滑块
::-webkit-scrollbar-thumb {
  background-color: #fafbfc;
  border-radius: 3px;
}
@media screen and (min-width: 3300px) {
  .Others6Charts .cars-in-out .data {
    min-height: 45px !important;
    padding: 33.23px 45.57px !important;
  }
  .Others6Charts .cars-in-out .data .d-left {
    font-size: 20px !important;
  }
  .Others6Charts .cars-in-out .data .d-right .d-item .title,
  .Others6Charts .cars-in-out .data .d-right .d-item .value {
    font-size: 20px !important;
  }
}
</style>
